import { Helmet } from "react-helmet-async";
import React from "react";
import CalendarioMensile from "../components/CalendarioMensile";

export default function Calendario() {
  return (
    <div data-testid="calendario-page" style={{ backgroundColor: "#002749" }}>
      <Helmet>
        <title>Calendario – ASD Rubiana Calcio</title>
        <meta name="description" content="Il calendario completo di partite, corsi in palestra ed eventi dell'ASD Rubiana Calcio, sempre aggiornato." />
        <meta property="og:title" content="Calendario – ASD Rubiana Calcio" />
        <meta property="og:description" content="Partite, corsi in palestra ed eventi dell'ASD Rubiana Calcio in Val di Susa." />
        <meta property="og:url" content="https://rubianacalcio.it/calendario" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://rubianacalcio.it/logo512.png" />
      </Helmet>

      {/* Hero */}
      <section className="relative border-b border-zinc-900 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-zinc-950/60 to-[#002749]" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 lg:py-32">
          <div className="text-overline text-yellow-400 mb-4">// Agenda</div>
          <h1 className="font-display font-black text-5xl sm:text-7xl tracking-tighter uppercase leading-none">
            Calendario<br />
            <span className="text-yellow-400">eventi</span>
          </h1>
          <p className="mt-6 max-w-2xl text-zinc-400">
            Partite, corsi in palestra ed eventi del club, tutti in un unico calendario sempre aggiornato.
          </p>
        </div>
      </section>

      {/* Contenuto */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <CalendarioMensile />
      </section>
    </div>
  );
}